import { createListenerMiddleware } from '@reduxjs/toolkit';

import { push } from 'modules/router/actions';
import { AppStartListening } from 'App/ListenerMiddleware';
import gatesApi from './service';
import { GateType } from './types/Gate';
import { getSearch } from 'modules/router/selectors';
import { addNotification } from 'modules/notifications/actions';
import { NotificationType } from 'modules/notifications/types/Notification';

const listenerMiddleware = createListenerMiddleware();
const startAppListening = listenerMiddleware.startListening as AppStartListening;

startAppListening({
  matcher: gatesApi.endpoints.loginGateMFA.matchFulfilled,
  effect: async (action, { dispatch, getState }) => {
    try {
      const { gateId } = action.payload;
      const { data: gate } = await dispatch(gatesApi.endpoints.getGate.initiate(gateId));

      if (gate) {
        if (gate.config.type === GateType.RELAY) {
          await dispatch(gatesApi.endpoints.openGate.initiate(gate.id)).unwrap();
          const search = getSearch(getState());
          dispatch(push(`/gates/success${search}`));
        }
      }
    } catch {
      dispatch(addNotification({
        title: { id: 'login.error.title', defaultMessage: 'Unable to login' },
        description: { id: 'gates.error.verificationFailed', defaultMessage: 'Verification failed. Please check your code and try again.' },
        type: NotificationType.ERROR,
      }));
    }
  },
});

export default listenerMiddleware;
